export default __webpack_public_path__ + "media/background-video.mp4";